import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentStarFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 5.955V15.5H2V.5h6.667C12.667.5 14 1.864 14 5.955M6.606 9.39l-.387-.162c-1.258-.524-1.887-.786-1.887-1.23s.63-.706 1.887-1.23l.387-.162.161-.387c.525-1.258.787-1.887 1.231-1.887s.706.63 1.23 1.887l.162.387.387.162c1.258.524 1.887.786 1.887 1.23s-.63.706-1.887 1.23l-.387.162-.162.387c-.524 1.258-.786 1.887-1.23 1.887s-.706-.63-1.23-1.887z"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentStarFilledSize16Glyph.displayName = 'DocumentStarFilledSize16Glyph';
